// extracted by mini-css-extract-plugin
export default {"bookingCalendarHeader":"style_bookingCalendarHeader__wQZ4B","prevIcon":"style_prevIcon__Rcypc","nextIcon":"style_nextIcon__JDLX1"};